import React, {useEffect, useState} from 'react';
import {Headline6} from "../../../components";
import {Col, Row} from "antd";
import {connect, useDispatch} from "react-redux";

import {fetchPatientById, setPatientDetailsLoading, updatePatientDetailsOwner} from "../../../app/Reducers";
import {appMessage, dialogCloser, emptyFun, kebabMenus, boldKeyCapitalizedValue, boldKeyCapitalizedValueGrayBackground, skelBars} from "../../../common/helpers";
import AuditLogViewer from "../../../components/AuditLogs/AuditLogViewer";

import KebabMenu from "../../../components/KebabMenu";
import {useSubscription} from "../../../hooks/MqttHooks/useSubscription";
import {apiRequest} from '../../../app/Apis';
import {usePermissionCheck} from '../../../hooks/usePermissionCheck';
import {useLocation, useNavigate} from 'react-router-dom';

function PatientInfoPane({ patient, setDetailsForm, navs, activeUser, ...props }) {
  const location = useLocation()
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [showAuditDialog, setShowAuditDialog] = useState(false);
  
const can_view_audit_logs = usePermissionCheck('view_audit_logs', false, [])
  const can_update_patient = usePermissionCheck('update_patient', false, [])
  
  const patientId = patient?.id || Number(location.pathname.substring(location.pathname.lastIndexOf('/') + 1))
  useEffect(() => {
    (async () => {
      if (!patient || (patientId !== patient.id)) {
        await dispatch(setPatientDetailsLoading(true))
        await dispatch(fetchPatientById(Number(patientId)))
        await dispatch(setPatientDetailsLoading(false))
        await dispatch(updatePatientDetailsOwner(patientId))
      }
    })().catch(e => console.log(e))
    return emptyFun
  }, [patient])
  
  
  const actionMenus = kebabMenus((can_update_patient && !patient.deleted_at), can_view_audit_logs, false)
  
  async function kebabMenuClick(e) {
    switch (actionMenus[e.key].title) {
      case 'Edit':
        await setDetailsForm(true);
        break
      case 'Audit':
        setShowAuditDialog(true);
        break
      case 'Delete':
        appMessage('Operation not allowed', 'error')
        break
      default:
        await setShowAuditDialog(false);
        await setDetailsForm(false);
    }
  }
  
  async function getDefaultBillingGroup(state) {
    const response = await apiRequest.get(`/billing-region?state=${state}`)
    let billingInfo = response.data.data
    let defaultGroup;
    if (billingInfo === 0) {
      let billingGroup = billingInfo?.billing_groups
      console.log('billingInfo', billingInfo.data.data)
      defaultGroup = billingGroup?.find(item => item.is_default === 'true')
      return defaultGroup
    } else {
      defaultGroup = 'No Billing Group'
    }
    console.log('defaultGroup', defaultGroup)
    return defaultGroup
  }
  
  const gettimezone = () => {
    const city = "Los Angeles";
    const date = new Date(); // Assuming this is the current date and time
    const options = { timeZone: "America/Los_Angeles", timeZoneName: "short" };
    const timeZoneAbbreviation = date.toLocaleString("en-US", options).split(" ")[2];
    
    console.log(timeZoneAbbreviation); // Output: "PST"
  }
  
  return (<div className="card-box">
    {showAuditDialog && <AuditLogViewer visible={showAuditDialog} onCancel={dialogCloser(setShowAuditDialog)}
                                        loading={false} resourceDescription={patient.name} resourceType={'Patient'}
                                        defaultValues={{ auditableId: patientId, auditable: 'patient', format: 'json' }}/>}
    <div className="flex-boy-row-space" style={{ width: "100%" }}>
      <Headline6>Primary Address</Headline6>
      {/*{( can_update_patient && !patient.deleted_at) ?
        <IconButton type={"button"} size={"small"} onClick={() => {
          setDetailsForm(true);
        }}> <EditOutlined
            fontSize={"small"} />
        </IconButton> : null}*/}
      <KebabMenu menus={actionMenus}
                 recordItem={patient}
                 handleMenuClick={kebabMenuClick} resource={'patient'} handleOk={null} handleCancel={null} confirmLoading={null}
                 showConfirmDialog={false}/>
    </div>
    {navs.patientDetailsLoading ? skelBars() : <Row gutter={[4, 4]} align={"stretch"} justify={"start"} style={{ width: '100%', margin: 0 }}>
      
      <Col xs={24} sm={24} md={24} lg={24} xl={24} flex={"auto"} style={{ width: '100%' }}>
        {boldKeyCapitalizedValueGrayBackground('Phone', patient.phone_no)}
        
        {boldKeyCapitalizedValue('City', patient.city || 'N/A')}
        {boldKeyCapitalizedValueGrayBackground('Address', `${patient.address_1}, ${patient.zip_code}, ${patient.city}, ${patient.state}`)}
        {boldKeyCapitalizedValue('Zip', patient.zip_code || 'N/A')}
        {boldKeyCapitalizedValueGrayBackground('State', patient.state)}
        {boldKeyCapitalizedValue('Time zone', patient.timezone || 'N/A')}
        {/* {boldKeyCapitalizedValue('Default Billing Group' , getDefaultBillingGroup(patient?.state))} */}
        {/* {boldKeyCapitalizedValue('', patient.address_2)} */}
        {/* {!activeUser?.facilityProfile && boldKeyCapitalizedValue('Smartsheet ID', patient.smartsheet_id || 'N/A')} */}
        
        {/* <div className="flex-box-address" style={{width: "100%"}}>
          <Subtitle1 style={{textAlign: 'left', flex: 1}}>Address</Subtitle1>
          <Body2 color="black" style={{textAlign: 'left', flex: 1}}>{patient.address_1}
            <br/> <br/>{patient.address_2}
          </Body2>
        </div>*/}
      </Col>
    </Row>}
  </div>);
}

const mapStateToProps = (state) => ({
  wounds: state.patients.patientWounds, patient: state.patients.selectedPatient,
  appConf: state.appConf, navs: state.navs, activeUser: state.auth?.activeUser
})
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(PatientInfoPane);
